<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item>YOU ARE HERE</b-breadcrumb-item>
      <b-breadcrumb-item>
        <router-link tag="a" to="/app/applications"> Applications</router-link>
      </b-breadcrumb-item>
      <b-breadcrumb-item class="fw-semi-bold">{{ formName }}</b-breadcrumb-item>
    </b-breadcrumb>

    <b-container fluid>
      <b-card>
        <b-row align-h="start">
          <b-col lg="4">
            <div>
              <b-button
                title="Combined PO"
                v-on:click="CombinedPO()"
                size="sm"
                variant="info"
                style="margin-right: 5px; color: white"
              >
                <b-icon icon="files" aria-label="Combined PO"></b-icon>
                Combined PO
              </b-button>
            </div>
          </b-col>
          <b-col lg="4"> </b-col>
          <b-col sm="4">
            <b-form-group
              label="Search"
              label-for="Search-input"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="Search-input"
                  v-model="search"
                  type="search"
                  placeholder="Type to Search"
                ></b-form-input>

                <b-input-group-append>
                  <b-button :disabled="!search" @click="search = ''"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <template v-slot:header>
          <b-row align-v="center">
            <b-col sm="auto" md="9">
              <div class="text-left">
                <h4>List Keterangan PO</h4>
              </div>
            </b-col>
            <b-col sm="auto" md="3">
              <div class="text-right">
                <b-button
                  title="Add"
                  v-on:click="AddKeteranganPO()"
                  size="sm"
                  variant="outline-success"
                  style="margin-right: 5px"
                >
                  <b-icon icon="journal-plus" aria-label="Add"></b-icon>
                  Add Keterangan PO
                </b-button>
                <!-- <b-button title="Add" size="sm" variant="success" v-on:click="AddNewCustomer()">
                                    <span>Add New Customer</span>
                                </b-button> -->
              </div>
            </b-col>
          </b-row>
        </template>
        <div class="d-flex justify-content-center mb-3">
          <b-spinner
            variant="primary"
            v-show="isLoading"
            label="Loading..."
          ></b-spinner>
        </div>
        <b-table
          :no-border-collapse="true"
          striped
          class="header-background"
          hover
          outlined
          show-empty
          responsive
          :per-page="paging.perPage"
          :current-page="paging.currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          sort-icon-left
          @filtered="onFiltered"
          :filter="search"
          :fields="fields"
          :items="dataTable"
        >
          <template #empty="scope">
            <p class="text-center">{{ scope.emptyText }}</p>
          </template>

          <!-- Est Employee -->
          <template #cell(created)="row">
            <span v-if="row.value !== null" v-html="FormatDate(row.value)"></span>
          </template> 

          <template #cell(action)="row">
            <b-button
              title="Print"
              size="xs"
              variant="outline-secondary"
              v-on:click="PrintData(row.item.id)"
              style="margin-right: 5px"
            >
              <b-icon icon="printer-fill" aria-label="Print"></b-icon>
            </b-button>
            <!-- <b-button
              title="View"
              size="xs"
              variant="outline-info"
              v-on:click="viewData(row.item.id)"
              style="margin-right: 5px"
            >
              <b-icon icon="eye-fill" aria-label="View"></b-icon>
            </b-button> -->
            <b-button
              title="Edit"
              size="xs"
              variant="outline-warning"
              v-on:click="editData(row.item.id)"
              style="margin-right: 5px"
            >
              <b-icon icon="pencil-fill" aria-label="Edit"></b-icon>
            </b-button>
            <!-- <b-button v-if="row.item.status == 'waiting_approval' " title="Approve" size="xs" variant="outline-primary" v-on:click="approveData(row.item.id)">
                            <b-icon icon="file-check" aria-label="Approve"></b-icon>

                        </b-button> -->
          </template>
        </b-table>
        <b-row>
          <b-col sm="4">
            Showing {{ showPerPage }} of {{ totalData }} entries
          </b-col>
          <b-col sm="4"> </b-col>
          <b-col sm="4" align-self="end" class="my-1">
            <b-pagination
              v-model="paging.currentPage"
              :total-rows="rows"
              :per-page="paging.perPage"
              align="right"
              size="sm"
            >
              <template #first-text><span class="">First</span></template>
              <template #prev-text><span class="">Prev</span></template>
              <template #next-text><span class="">Next</span></template>
              <template #last-text><span class="">Last</span></template>
              <template #page="{ page, active }">
                <b v-if="active">{{ Pagination(page) }} {{ page }}</b>
                <i v-else>{{ page }}</i>
              </template>
            </b-pagination>
          </b-col>
        </b-row>

        <template>
          <b-modal
            v-model="showCombinedPO"
            ok-variant="success"
            cancel-variant="warning"
            header-bg-variant="secondary"
            hide-footer
            hide-backdrop
            size="md"
            no-close-on-backdrop
            title="Combined PO"
          >
            <div id="modal">
              <b-form-group
                label="Group Customer *"
                label-for="Group Customer"
                label-cols-sm="4"
                label-align-sm="left"
                label-size="sm"
              >
                <v-select
                  :clearable="false"
                  v-model="selectCustomerGroup"
                  @input="InputCustomerGroup"
                  label="group"
                  :reduce="(data) => data.group"
                  :options="optCustomerGroup"
                  placeholder="Select Group"
                ></v-select>
              </b-form-group>

              <b-form-group
                label="Customer Name"
                label-for="Customer Name"
                label-cols-sm="4"
                label-align-sm="left"
                label-size="sm"
              >
                <v-select
                  :clearable="false"
                  :disabled="!selectCustomerGroup"
                  v-model="selectCustomerId"
                  @input="InputCustomer"
                  label="name"
                  :reduce="(data) => data.id"
                  multiple
                  tag
                  :options="optCustomer"
                  placeholder="Select Customer"
                ></v-select>
              </b-form-group>

              <b-form-group
                label="Order Date"
                label-for="Order Date"
                label-cols-sm="4"
                label-align-sm="left"
                label-size="sm"
              >
                <v-select
                  :disabled="!selectCustomerGroup"
                  :clearable="false"
                  v-model="selectOrderDate"
                  @input="InputOrderDate"
                  multiple
                  tag
                  label="date_str"
                  :reduce="(data) => data.date"
                  :options="optOrderDate"
                  placeholder="Select Order Date"
                ></v-select>
              </b-form-group>

              <b-form-group
                label="Sample No *"
                label-for="Sample No"
                label-cols-sm="4"
                label-align-sm="left"
                label-size="sm"
              >
                <v-select
                  :disabled="!selectCustomerGroup"
                  :clearable="false"
                  v-model="selectSample"
                  multiple
                  tag
                  label="sample"
                  :reduce="(data) => data.sample"
                  :options="optSample"
                  placeholder="Select Sample"
                ></v-select>
              </b-form-group>
              <div class="text-right" v-if="selectSample">
              <b-button
                title="Print PO"
                v-on:click="printPoCombined()"
                size="sm"
                variant="secondary"
                style="margin-right: 5px; color: white"
              >
                <b-icon icon="printer-fill" aria-label="Print PO"></b-icon>
                Print PO
              </b-button>
              </div>
            </div>
          </b-modal>
        </template>

        <Loader
          v-if="isLoadingData"
          fullPage
          useOverlay
          loader="spinner"
        ></Loader>
        <PrintKetPO />
        <PrintKetPOCombine />
      </b-card>
    </b-container>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Loader from "@/components/Loader/Loader";
import { fnPOST } from "../../../../api/api-methods";
import { APIPATH_SALESFORCE } from "../../../../api/api-paths";
import PrintKetPO from "./printPDFKeteranganPO.vue";
import PrintKetPOCombine from "./printPDFKeteranganPOCombine.vue";
import { EventBus } from "./eventBus";

export default {
  components: {
    Loader,
    PrintKetPO,
    PrintKetPOCombine,
  },
  data() {
    return {
      isLoadingData: false,
      monthNames: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      formName: "List Keterangan PO",
      sortBy: "created",
      sortDesc: true,
      roles_list: [],
      dataTable: [],
      dataTableCombined: [],
      fields: [
        { key: "action", label: "Action", sortable: false },
        { key: "project_id", label: "project id", sortable: true },
        { key: "po", label: "PO", sortable: true, class: "min-10vw" },
        { key: "part_no", label: "Part", sortable: true },
        {
          key: "customer_name",
          label: "Customer Name",
          sortable: true,
          class: "min-10vw",
        },
        {key:'created', label:'created at', sortable:true, class: "min-10vw"},
        // {key:'sub_sector', label:'sub sector', sortable:true},
        // {key:'est_employee', label:'EST Emp', tdClass: 'align_right', sortable:true},
      ],
      showPerPage: 0,
      totalData: 0,
      search: null,
      PageNow: 1,
      paging: {
        perPage: 10,
        currentPage: 1,
      },
      isLoading: false,
      form_filter: null,
      form: {
        role: null,
        start_limit: null,
        end_limit: null,
        user_nik: null,
        username: null,
      },
      showCombinedPO: false,
      optCustomerGroup: [],
      optCustomer: [],
      optOrderDate: [],
      optSample: [],
      selectCustomerId: [],
      selectCustomerGroup: null,
      selectOrderDate: null,
      selectSample: null,
    };
  },
  computed: {
    ...mapGetters("session", ["userData"]),
    // ...mapState('sales_force', ['stCstm','stCstmCount']),
    rows() {
      if (this.totalData != null) {
        return this.totalData;
      }
    },
  },
  methods: {
    ...mapActions("session", ["showNotification"]),
    // ...mapActions('sales_force', ['getDashboardMasterCustomer']),

    setData() {
      let roles = this.userData.roles;
      if (roles.length > 0) {
        for (let data in roles) {
          if (roles[data].app == "SFC") {
            let lower = roles[data].role_list.map((string) => {
              return string.toLowerCase();
            });
            this.roles_list = lower;
          }
        }
      }
      if (this.roles_list.includes("sales")) {
        this.roles_list.push("dept-head");
      }
      if (
        this.roles_list.includes("superuser") ||
        this.roles_list.includes("dept-head") ||
        this.roles_list.includes("div-head") ||
        this.roles_list.includes("sales")
      ) {
        this.LoadData();
      } else {
        this.showNotification({
          type: "error",
          message: "You don't have permissions to view this page",
        });
        this.$router.push({ name: "ApplicationPage" });
      }
    },

    LoadData() {
      // start loading
      (this.isLoadingData = true),
        fnPOST(APIPATH_SALESFORCE.listKeteranganPO, {})
          .then((rsp) => {
            setTimeout(() => {
              this.isLoadingData = false;
            }, 500);
            this.dataTable = rsp.data.payload;
            this.totalData = rsp.data.payload.length;
            this.showPerPage = this.paging.perPage;
            if (this.totalData < this.paging.perPage) {
              this.showPerPage = this.totalData;
            }
            if (this.totalData == 0) {
              this.showNotification({
                type: "info",
                message: "Data Not Found",
              });
            }
          })
          .catch((err) => {
            setTimeout(() => {
              this.isLoadingData = false;
            }, 500);
            if (err.response.status !== 401) {
              this.showNotification({
                type: "error",
                message: "Gagal Load Data, Silahkan Coba Kembali",
              });
            }
            setTimeout(() => {
              this.isLoadingData = false;
            }, 500);
          });
    },
    openCombined() {
      this.selectCustomerId = []
      this.selectCustomerGroup = null
      this.selectOrderDate = null
      this.selectSample = null
      let customer_id = [];
      let customer_group = [];
      this.optCustomer = [];
      this.dataTableCombined.forEach((data) => {
        if (!customer_id.includes(data.customer_id)) {
          customer_id.push(data.customer_id);
          this.optCustomer.push({
            id: data.customer_id,
            name: data.customer_name,
          });
        }
        if (!customer_group.includes(data.customer_group)) {
          customer_group.push(data.customer_group);
          this.optCustomerGroup.push({
            group: data.customer_group,
          });
        }
      });
      this.showCombinedPO = true;
    },
    CombinedPO() {
      this.isLoadingData = true;
      this.optCustomerGroup = [];
      fnPOST(APIPATH_SALESFORCE.getKetPoCombine, {})
        .then((rsp) => {
          this.isLoadingData = false;
          this.dataTableCombined = rsp.data.payload;
          this.openCombined();
        })
        .catch((err) => {
          this.isLoadingData = false;
          if (err.response.status !== 401) {
            this.showNotification({
              type: "error",
              message: "Gagal Load Data, Silahkan Coba Kembali",
            });
          }
        });
    },

    FormatDate(value) {
      if (value == null || value == undefined || value == "") {
        return " ";
      } else {
        let date = new Date(value);
        let day = date.getDate();
        if (String(day).length == 1) {
          day = "0" + String(day);
        }
        let year = date.getFullYear();
        let bulan = this.monthNames[date.getMonth()];
        date = day + " " + bulan + " " + year;
        return date;
      }
    },

    InputCustomerGroup() {
      this.selectOrderDate = null;
      this.selectSample = null;
      this.selectCustomer = null;
      this.isLoadingData = true;
      this.optCustomer = [];
      this.optOrderDate = [];
      let order_date = [];
      let customer_id = [];
      this.optSample = [];
      let sample = [];
      this.dataTableCombined.forEach((data) => {
        if (data.customer_group == this.selectCustomerGroup) {
          if (!customer_id.includes(data.customer_id)) {
          customer_id.push(data.customer_id);
          this.optCustomer.push({
            id: data.customer_id,
            name: data.customer_name,
          });
          }
        }
        if (data.customer_group == this.selectCustomerGroup) {
          if (!(order_date.includes(data.order_date))) {
            order_date.push(data.order_date);
            this.optOrderDate.push({
              date: data.order_date,
              date_str: this.FormatDate(data.order_date),
            });
          }
        }

        if (data.customer_group == this.selectCustomerGroup) {
          if (!(sample.includes(data.sample_no))) {
            sample.push(data.sample_no);
            this.optSample.push({
              sample: data.sample_no,
            });
          }
        }
      });
      console.log(this.optOrderDate)
      setTimeout(() => {
        this.isLoadingData = false;
      }, 100);
    },

    InputCustomer() {
      this.selectOrderDate = null;
      this.selectSample = null;
      this.isLoadingData = true;
      this.optOrderDate = [];
      let order_date = [];
      this.optSample = [];
      let sample = [];
      this.dataTableCombined.forEach((data) => {
        if (this.selectCustomerId.includes(data.customer_id) && this.selectCustomerGroup.includes(data.customer_group)) {
          if (!(order_date.includes(data.order_date))) {
            order_date.push(data.order_date);
            this.optOrderDate.push({
              date: data.order_date,
              date_str: this.FormatDate(data.order_date),
            });
            console.log(data)
          }
        }
        if (this.selectCustomerId.includes(data.customer_id) && this.selectCustomerGroup.includes(data.customer_group)) {
          if (!(sample.includes(data.sample_no))) {
            sample.push(data.sample_no);
            this.optSample.push({
              sample: data.sample_no,
            });
            console.log(data)
          }
        }
      });
      console.log(this.optOrderDate)
      setTimeout(() => {
        this.isLoadingData = false;
      }, 100);
    },

    InputOrderDate() {
      this.isLoadingData = true;
      this.selectSample = null
      this.optSample = [];
      let sample = [];
      console.log(this.selectCustomerId); //this.selectCustomerId 
      this.dataTableCombined.forEach((data) => {
        
        if (this.selectOrderDate.includes(data.order_date) && this.selectCustomerGroup.includes(data.customer_group)) {
          if (this.selectCustomerId.length>0) {
            if (this.selectCustomerId.includes(data.customer_id)) {
              if (!(sample.includes(data.sample_no))) {
                sample.push(data.sample_no);
                this.optSample.push({
                  sample: data.sample_no,
                });
              }
            }
          } else {
            if (!(sample.includes(data.sample_no))) {
              sample.push(data.sample_no);
              this.optSample.push({
                sample: data.sample_no,
              });
            }
          }
        }
      });
      setTimeout(() => {
        this.isLoadingData = false;
      }, 100);
    },

    printPoCombined() {
      const param = {
        idData: this.selectCustomerId,
        groupCustomer:this.selectCustomerGroup,
        orderDate: this.selectOrderDate,
        sample: this.selectSample,
      };
      EventBus.$emit("open-ketpo-combine", param);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalData = filteredItems.length;
      this.paging.currentPage = 1;
      this.showPerPage = filteredItems.length;
      if (filteredItems.length >= this.paging.perPage) {
        this.showPerPage = this.paging.perPage;
      }
    },
    Pagination(value) {
      if (value !== this.PageNow) {
        if (value > this.PageNow) {
          this.PageNow = value;
          // this.nextPage()
          this.showPerPage = this.paging.perPage * this.PageNow;
          if (this.showPerPage >= this.totalData) {
            this.showPerPage = this.totalData;
          }
        } else {
          this.PageNow = value;
          this.showPerPage =
            this.showPerPage -
            (this.showPerPage - this.paging.perPage * this.PageNow);
          if (this.showPerPage <= this.paging.perPage) {
            this.showPerPage = this.paging.perPage;
          }
        }
      }
    },
    FormatCommaNumber(param) {
      let format = param;
      if (param == null || param == undefined || param == "") {
        format = null;
      } else {
        // format = param.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        format = param.toString();
      }
      return format;
    },

    AddKeteranganPO() {
      this.$router.push({ name: "SFCKetPOForm" });
    },
    viewData(data) {
      this.$router.push({
        name: "SFCKetPOForm",
        params: { page: "view", idData: data },
      });
    },
    PrintData(data) {
      const param = data;
      EventBus.$emit("open-ketpo", param);
    },
    PrintDataCombined(data) {

    },
    editData(data) {
      this.$router.push({
        name: "SFCKetPOForm",
        params: { page: "edit", idData: data },
      });
    },
  },
  created() {
    this.setData();
  },
};
</script>
<style src="../SalesForce.scss" lang="scss" scoped />
